import { useState } from 'react';
import styles from '@/styles/footer.module.scss';
import { useLocalization } from '@/hooks/useLocalization';

const SendIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" /></svg>
);

export default function Footer({ onSend }) {
  const { t } = useLocalization();
  const [value, setValue] = useState('');

  const handleSend = () => {
    const trimmed = value.trim();
    if (trimmed) {
      onSend(trimmed);
      setValue('');
    }
  };

  return (
    <div className={styles.footer}>
      <input
        className={styles.input}
        type="text"
        placeholder={t('footer.inputPlaceholder')}
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleSend()}
      />
      <button className={styles.sendBtn} onClick={handleSend} type="button">
        <SendIcon />
      </button>
    </div>
  );
}
